<template>
	<div>
		<footer class="section" style="background-color: #3a3a3a;">
		    <div class="footer-top section-padding">
		        <div class="container">
		            <div class="row row-cols-lg-5 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n8">
		                <div class="col mb-8">
		                    <div class="footer-widget footer-about">
		                        <div class="footer-logo" style="display: flex;align-items: center;">
		                            <router-link :to="{ path: '/'}"><img src="@/assets/images/logo/logo.png" alt="logo" style="width: 60px;height: 60px;"></router-link>
									<p style="flex: 1;margin-left: 10px;">筑壳</p>
		                        </div>
								<div><p style="color: #9e9ea6;">场景化建筑设计装饰<br/>内容发现中心</p></div>
		                    </div>
		                </div>
		                <div class="col mb-8">
		                    <div class="footer-widget footer-list">
		                        <h4 class="footer-title">分类</h4>
		                        <ul style="padding-left: 0;">
									<li><router-link :to="{ path: '/project'}" tag="a" target="_blank">案例</router-link></li>
									<li><router-link :to="{ path: '/specialColumn' }" tag="a" target="_blank">专栏</router-link></li>
									<li><router-link :to="{ path: '/product' }" tag="a" target="_blank">产品</router-link></li>
									<li><router-link :to="{ path: '/show' }" tag="a" target="_blank">展厅</router-link></li>
									<li><router-link :to="{ path: '/exhibition' }" tag="a" target="_blank">展会</router-link></li>
									<li><router-link :to="{ path: '/promotions' }" tag="a" target="_blank">找优惠</router-link></li>
									<li><router-link :to="{ path: '/appDownload' }" tag="a" target="_blank">筑壳客户端</router-link></li>
		                        </ul>
		                    </div>
		                </div>
		                <div class="col mb-8">
		                    <div class="footer-widget footer-list">
		                        <h4 class="footer-title">关于我们</h4>
		                        <ul style="padding-left: 0;">
		                            <li>
		                                <span class="title"><i class="dlicon ui-2_phone"></i></span>
										<span class="desc">
											<router-link tag="a" target="_blank" :to="{ path: '/aboutUs'}">关于我们</router-link>
										</span>
		                            </li>
		                            <li>
		                                <span class="title"><i class="dlicon ui-1_email-85"></i></span>
		                                <span class="desc"><router-link tag="a" target="_blank" :to="{ path: '/contant'}">加入我们</router-link></span>
		                            </li>
		                            <li>
		                                <span class="title"><i class="dlicon ui-1_home-51"></i></span>
		                                <span class="desc">
											<router-link tag="a" target="_blank" :to="{ path: '/copyrightNotice'}">版权声明</router-link>
										</span>
		                            </li>
		                        </ul>
		                    </div>
		                </div>
		                <div class="col mb-8">
		                    <div class="footer-widget footer-newsletter">
		                        <h4 class="footer-title">申请入驻</h4>
		                        <div id="mc_embed_signup" class="subscribe-form">
		                            <form id="mc-embedded-subscribe-form" class="validate" novalidate="" target="_blank" name="mc-embedded-subscribe-form" method="post" action=" ">
		                                <div id="mc_embed_signup_scroll" class="mc-form">
		                                    <Input v-model="phone" style="margin-bottom: 10px;" size="large" placeholder="请输入认证手机号"  />
		                                    <Select v-model="cate_id" size="large" style="height:50px;margin-bottom: 20px;">
		                                    	<Option v-for="item in cateList" :value="item.id" :key="item.id">{{ item.cate_name }}</Option>
		                                    </Select>
		                                    <Button type="success"   size="large" @click="userApply">提交申请</Button>
		                                </div>
		                            </form>
		                        </div>
		                    </div>
		                </div>
						<div class="col mb-8">
		                    <div class="footer-widget footer-list">
		                        <h4 class="footer-title">关注我们</h4>
		                       <div class="social-icon-style mb-5">
		                           <a class="facebook" href="https://weibo.com/u/7764675727" target="_black"><img src="@/assets/images/testimonial/群组 2@2x.png" alt=""></a>
								   <Poptip trigger="hover" content="content">
									   <img src="@/assets/images/testimonial/群组@2x.png" alt="" style="width: 31px;height: 31px;margin-right: 10px;">
									   <div slot="content">
										   <img src="@/assets/images/微信视频号.png" alt="">
									   </div>
								   </Poptip>
								   <Poptip trigger="hover" content="content">
									   <img src="@/assets/images/testimonial/群组 3@2x.png" alt="" style="width: 31px;height: 31px;margin-right: 10px;">
									   <div slot="content">
										   <img src="@/assets/images/抖音.png" alt="">
									   </div>
								   </Poptip>
		                           <a class="behance" href="https://www.xiaohongshu.com/user/profile/6297006800000000210252f4" target="_black"><img src="@/assets/images/testimonial/群组 4@2x.png" alt=""></a>
		                       </div> 
							   <div class="social-icon-style mb-5">
							       <a class="zhihu" href="https://www.zhihu.com/people/42-58-37-64" target="_black"><img src="@/assets/images/other (1).png" alt=""></a>
								   <Poptip trigger="hover" content="content">
									   <img src="@/assets/images/other (2).png" alt="" style="width: 31px;height: 31px;margin-right: 10px;">
									   <div slot="content">
										   <img src="@/assets/images/快手.png" alt="">
									   </div>
								   </Poptip>
							       <a class="blbl" href="https://space.bilibili.com/1798548694" target="_black"><img src="@/assets/images/other (3).png" alt=""></a>
							       <a class="douban" href="https://www.douban.com/people/257741962/?_i=4652198DcYu4CG" target="_black"><img src="@/assets/images/other (4).png" alt=""></a>
							   </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		    <div class="footer-bottom">
		        <div class="container">
		            <div class="copyright text-center">
		                <p style="color: #9e9ea6;">
		                    Copyright © 2022.筑壳（深圳）科技有限公司 | 备案号：<a href="https://beian.miit.gov.cn/">粤ICP备2022044914号-1</a> <img src="@/assets/images/icp.png" alt="">
							<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702004726">粤公网安备44030702004726号</a>
		                </p>
		            </div>
		        </div>
		    </div>
		</footer>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		userApply
	 } from '@/api'
	 export default {
	   data() {
			return {
				cateList: [
					{id: 1,  cate_name: "设计公司"},
					{id: 2,  cate_name: "装修公司"},
					{id: 3,  cate_name: "材料供应商"},
					{id: 4,  cate_name: "咨询/顾问公司"}
				],
				
				phone: '',
				cate_id: ''
			}
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			// 提交认证
			async userApply() {
				if(!this.isLogin) {
					alert('请登录后操作')
					return false
				}
			if (!this.phone) {
				alert('请填写手机号码')
				return 
			}
			if (!/^1(3|4|5|7|8|9|6)\d{9}$/i.test(this.phone)) {
				alert('请输入正确的手机号码')
				return 
			}
			if(!this.cate_id) {
				alert('请选择入驻类型')
				return 
			}
				await userApply({
					phone: this.phone,
					cate_id: this.cate_id
				}).then(res => {
					this.$Message.success(res.msg);
					this.phone = ''
					this.cate_id = ''
				}).catch(err => {
					this.$Message.success(err.msg);
					this.phone = ''
					this.cate_id = ''
				})
			},
			
		}
	}
</script>

<style>
</style>
